(function () {
  var TRIGGER_EVENTS = ['pointerdown', 'touchstart', 'keydown', 'wheel', 'scroll', 'mousemove'];
  var LISTENER_OPTIONS = { once: true, passive: true };
  var loaded = false;

  function load() {
    if (loaded) return;
    loaded = true;

    TRIGGER_EVENTS.forEach(function (type) {
      window.removeEventListener(type, load, LISTENER_OPTIONS);
    });

    var s = document.createElement('script');
    var h = document.querySelector('head') || document.body;
    s.src = 'https://acsbapp.com/apps/app/dist/js/app.js';
    s.async = true;
    s.onload = function () {
      acsbJS.init({
        statementLink: '',
        footerHtml: '',
        hideMobile: false,
        hideTrigger: false,
        disableBgProcess: false,
        language: 'en',
        position: 'left',
        leadColor: '#146FF8',
        triggerColor: '#146FF8',
        triggerRadius: '50%',
        triggerPositionX: 'left',
        triggerPositionY: 'bottom',
        triggerIcon: 'people',
        triggerSize: 'bottom',
        triggerOffsetX: 90,
        triggerOffsetY: 30,
        mobile: {
          triggerSize: 'normal',
          triggerPositionX: 'left',
          triggerPositionY: 'bottom',
          triggerOffsetX: 80,
          triggerOffsetY: 30,
          triggerRadius: '20',
        },
      });
    };
    h.appendChild(s);
  }

  window.loadAccessibilityWidget = load;

  var hasSavedPreferences = false;
  try {
    var state = JSON.parse(window.localStorage.getItem('acsbState') || '{}');
    hasSavedPreferences = !!state.actions && Object.keys(state.actions).length > 0;
  } catch (e) {}

  if (hasSavedPreferences) {
    load();
    return;
  }

  TRIGGER_EVENTS.forEach(function (type) {
    window.addEventListener(type, load, LISTENER_OPTIONS);
  });
})();
